import { useCallback, useState } from 'react'
import useEventListener from 'src/hooks/useEventListener'
import { useModalState } from 'src/hooks/useModalState'
import ModalTimeSessionTrack from './ModalTimeSessionTrack'
import ModalVideoSessionTrack from './ModalVideoSessionTrack'

const OPEN_TRACK_SESSION_EVENT = 'open-track-session'

const TIME_TRACK_MODAL = 'TIME_TRACK_MODAL'
const VIDEO_TRACK_MODAL = 'VIDEO_TRACK_MODAL'

export const trackSessionModalAction = {
  openTimeTrack: (session) => {
    const ev = new CustomEvent(OPEN_TRACK_SESSION_EVENT, { detail: { type: TIME_TRACK_MODAL, session } })
    document.dispatchEvent(ev)
  },
  openVideoTrack: (session) => {
    const ev = new CustomEvent(OPEN_TRACK_SESSION_EVENT, { detail: { type: VIDEO_TRACK_MODAL, session } })
    document.dispatchEvent(ev)
  }
}

export default function SessionTrackControl () {
  const { handleClose, handleOpen, isModalVisible } = useModalState()
  const [modalType, setModalType] = useState('')
  const [session, setSession] = useState(null)

  const listener = useCallback(({ detail: { type, session } }) => {
    setModalType(type)
    setSession(session)
    handleOpen()
  }, [])

  const handleModalClose = () => {
    setSession(null)
    handleClose()
    setModalType('')
  }

  useEventListener(OPEN_TRACK_SESSION_EVENT, listener, document)

  return (
    <>
      <ModalTimeSessionTrack
        visible={isModalVisible && modalType === TIME_TRACK_MODAL}
        session={session}
        onClose={handleModalClose}
      />
      {
        session && modalType === VIDEO_TRACK_MODAL && <ModalVideoSessionTrack
          visible={isModalVisible && modalType === VIDEO_TRACK_MODAL}
          session={session}
          onClose={handleModalClose}
        />
      }
    </>
  )
}
